import ApiService from "@/services/apiService";
import MeinProfilBearbeitenForm from "./MeinProfilBearbeitenForm.vue";
import { createApp } from "vue";

let loginAppContainer = document.getElementById("mein-profil-bearbeiten");

if(loginAppContainer) {
    ApiService.create();
    const app= createApp(MeinProfilBearbeitenForm, { container:loginAppContainer });

    app.mount(loginAppContainer);
}


